"use client";

import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import color from "@/style/theme/Color";

interface HorizontalCardProps {
  gambar?: string;
  date: string;
  title: string;
  content: string;
}

const HorizontalCard: React.FC<HorizontalCardProps> = (props) => {
  const [imgError, setImgError] = useState(false);

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        margin: "auto",
        transition: "all 0.3s ease",
        borderRadius: "16px",
        border: "1px solid rgba(0,0,0,0.05)",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
        cursor: "pointer",
        "&:hover": {
          boxShadow: `0 12px 32px ${color.blue}20`,
          transform: "translateY(-4px)"
        }
      }}
    >
      <CardContent
        sx={{
          padding: { xs: "20px", md: "24px" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: "24px",
          alignItems: { xs: "center", sm: "flex-start" },
          "&:last-child": { paddingBottom: { xs: "20px", md: "24px" } }
        }}
      >
        {props.gambar && !imgError ? (
          <Box
            sx={{
              width: { xs: "100%", sm: "140px" },
              height: { xs: "200px", sm: "140px" },
              flexShrink: 0,
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={`${process.env.NEXT_PUBLIC_API_URL}/storage/pengumuman/${props.gambar}`}
              alt="Gambar Pengumuman"
              onError={() => setImgError(true)}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: { xs: "100%", sm: "140px" },
              height: { xs: "120px", sm: "140px" },
              flexShrink: 0,
              borderRadius: "12px",
              backgroundColor: `${color.primary}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Typography variant="caption" sx={{ color: color.primary, opacity: 0.5, fontWeight: 600 }}>
              No Img
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1
          }}
        >
          <Typography 
            variant="caption" 
            sx={{ 
              fontWeight: 600, 
              color: color.blue,
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              mb: 1
            }}
          >
            {props.date}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: color.primary,
              fontWeight: 800,
              lineHeight: 1.3,
              mb: 1.5,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            }}
          >
            {props.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              lineHeight: 1.6,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            }}
          >
            {props.content}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default HorizontalCard;
